import { api } from 'agent';
import { PersonDTO } from '@behavior/inventories/dto/PersonDTO';

export function getHsePersonAutocomplete(name: string): Promise<PersonDTO[]> {
  return api
    .get('/persons/autocomplete', false, { name, isHse: true })
    .then((response: { data: PersonDTO[] }) => response.data);
}
